/**
 * Calculate password strength level (1-4)
 * @param {string} password - The password to evaluate
 * @returns {{ level: number, label: string }} - Strength level (1-4) and label
 */
export const calculatePasswordStrength = (password) => {
  if (!password) {
    return { level: 0, label: '' };
  }

  const hasMinLength = password.length >= 8;
  const hasLowercase = /[a-z]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[^\w]/.test(password);

  if (!hasMinLength) {
    return { level: 1, label: 'Too short' };
  }

  let score = 0;
  if (hasLowercase) score++;
  if (hasUppercase) score++;
  if (hasNumber) score++;
  if (hasSpecialChar) score++;

  if (score <= 1) {
    return { level: 1, label: 'Weak' };
  } else if (score === 2) {
    return { level: 2, label: 'Fair' };
  } else if (score === 3) {
    return { level: 3, label: 'Good' };
  } else {
    return { level: 4, label: 'Strong' };
  }
};
